import { connect } from "react-redux";
import ListTag from "./List";
import { bindActionCreators } from "redux";
import { tagList } from "services/redux/Valet/AddValet/action";

const mapStateToProps = (state) => ({
    tagListing : state.CreateValet.tagListing,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        tagList
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ListTag);